import React, { useMemo } from "react";

import PropTypes from "prop-types";

import { ACTIVITY_TYPES } from "Constants/constants";
import activityTemplates from "src/organization/common/components/activities/activityTemplates";

import * as S from "./style";

const ActivityTooltip = ({ activity }) => {
  const [icon, title] = useMemo(() => {
    if (!activity) return [];

    const template =
      activityTemplates[activity.type] || activityTemplates.unknown;

    const showCommitTooltip =
      (activity.type === ACTIVITY_TYPES.ENVIRONMENT.PUSH ||
        activity.type === ACTIVITY_TYPES.ENVIRONMENT.MERGE) &&
      activity.payload.commits;

    const title = showCommitTooltip ? (
      <>
        <b>{activity.payload.commits[0].sha.slice(0, 7)}</b>&nbsp;-{" "}
        {activity.payload.commits[0].message}
      </>
    ) : (
      template.title({ activity })
    );

    return [template.icon, title];
  }, [activity]);

  if (!activity) return null;

  return (
    <S.Layout>
      <S.Activity>
        <S.ActivityIcon>{icon}</S.ActivityIcon>
        <S.ActivityTitle>{title}</S.ActivityTitle>
      </S.Activity>
    </S.Layout>
  );
};

ActivityTooltip.propTypes = {
  activity: PropTypes.object.isRequired
};

export default React.memo(ActivityTooltip);
